import { useMemo } from 'react';
import { configTableColumns } from '../../../constants/tableColumns';
import useConfigActions from '../../../hooks/APIHooks/appointments/useConfigActions';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import CreateConfigAction from './CreateConfigAction';

const ShowAllConfigs = () => {
  // integration of API hooks here
  const { getConfigListHandler } = useConfigActions('configList');

  // integration of custom hooks here
  const { featureBasedPermissions } =
    useCheckUserFeaturePermissions('serviceConfig');

  console.log('CONFIG LIST: ', getConfigListHandler.data?.data);

  // formatting table column here
  const configList = useMemo(() => {
    if (!getConfigListHandler.data?.is_success) return [];

    return getConfigListHandler.data.data.map((config) => ({
      ...config,
      service_name: config.service_data.name,
    }));
  }, [getConfigListHandler.data]);

  // rendering show all configurations section component here
  return (
    <section>
      {getConfigListHandler.isLoading ? (
        <AcademiaLoading />
      ) : getConfigListHandler.isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader headerText='All Configurations' />
            <AcademiaTable
              data={configList}
              columns={configTableColumns}
              tableToolbarComponent={
                <CreateConfigAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
              notFoundMessage='No configurations found!'
            />
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : getConfigListHandler.isError ? (
        <AcademiaNotFound message='Failed to load configuration data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllConfigs;
